import {router, loginPage, getFirstRoute} from '../../router'

import userApiModule from './user'
import addressApiModule from './address'
import serviceApiModule from './service'
import messageApiModule from './message'

const appStore = {
  modules: {
    'address': addressApiModule,
    'message': messageApiModule,
    'service': serviceApiModule,
    'user': userApiModule
  },
  actions: {
    /**
     * onLogin
     */
    onLogin (context) {
      const redirectPage = context.rootState.route.query.redirect
      if (context.getters.loggedIn) {
        // Make sure the user account has been retrieved
        context.dispatch('userAccountRegister')
          .then(() => {
            const targetPage = getFirstRoute(context.getters.validationRequired, context.getters.newUser, redirectPage)
            console.log('Logged in now! Redirect to %s', targetPage)
            router.push(targetPage)
          })
      } else {
        console.log('Logged out now :( Redirect to the Login page (%s)', loginPage)
        router.push(loginPage)
      }
    }
  }
}

export default appStore



// WEBPACK FOOTER //
// ./src/store/app/index.js